<template>
  <svg
    width="40"
    height="43"
    viewBox="0 0 40 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5482 38.0401H3V5H36.0401V38.0401H31.198"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M22.5482 38.0401H3V5H36.0401V38.0401H31.198"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M3.79453 22.0007H22.0235V11.9268"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M28.7694 22H22.0235"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M17.1814 26.7969V38.0401"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
    <path
      d="M17.1814 26.7969V38.0401"
      stroke="#4D00FF"
      stroke-width="2"
      stroke-miterlimit="10"
    />
  </svg>
</template>
